export const TimerComponent = ({
  type = "HH",
  value = 0,
}: {
  type: "HH" | "MM" | "SS";
  value: number;
}) => {
  return (
    <div className="flex items-center gap-1 w-fit relative">
      <div className="absolute border-[0.5px] border-border-strong rounded-[3px] w-5 h-4 -top-2 lg:top-[-0.4rem] start-1.5 lg:start-[0.65rem] bg-white flex items-center justify-center">
        <p className="text-[0.5rem] font-light text-muted-foreground">{type}</p>
      </div>
      <div className="border border-muted-foreground rounded-xs w-8 h-10 lg:w-10 lg:h-10 flex items-center justify-center">
        <p className="flex-1 text-center font-bold text-sm lg:text-base">
          {String(value).padStart(2, "0")}
        </p>
      </div>
      {(type === "HH" || type === "MM") && <>:</>}
    </div>
  );
};
